import { ModuleParamGlobConfigService } from 'src/app/core/service/moduleFieldConfig/module-param-glob-config.service';

export class CategoryTypeModuleParamModel {
  constructor(private moduleParamConfigGlob: ModuleParamGlobConfigService) {}

  paramData = {
    title: {
      label: this.moduleParamConfigGlob.getLabel('categorytype', 'title', 'Category Type'),
    },
    subtitle: {
      label: this.moduleParamConfigGlob.getLabel('categorytype', 'subtitle', 'Category Type Details'),
    },
    basicDetail: {
      label: this.moduleParamConfigGlob.getLabel('categorytype', 'basicDetail', 'Basic Details'),
    },
    name: {
      label: this.moduleParamConfigGlob.getLabel('categorytype', 'name', 'Name'),
    },
    name_key: {
      label: this.moduleParamConfigGlob.getLabel('categorytype', 'name_key', 'Name Key'),
    },
    description: {
      label: this.moduleParamConfigGlob.getLabel('categorytype', 'description', 'Description'),
      isVisible: this.moduleParamConfigGlob.isVisible('categorytype', 'description'),
    },
    party_type: {
      label: this.moduleParamConfigGlob.getLabel('categorytype', 'categorytype', 'Business Associate'),
    },
    category_type: {
      label: this.moduleParamConfigGlob.getLabel('categorytype', 'categorytype', 'Category Type'),
    },
  };
}
